"use strict";

var _jsxRuntime = require("react/jsx-runtime");
module.exports = ({
  title,
  titleId,
  size,
  color,
  ...props
}) => /*#__PURE__*/(0, _jsxRuntime.jsxs)("svg", {
  ...props,
  viewBox: "0 0 24 24",
  height: size,
  width: size,
  fill: color,
  role: title ? 'img' : undefined,
  "aria-hidden": !title,
  "aria-labelledby": titleId,
  children: [title ? /*#__PURE__*/(0, _jsxRuntime.jsx)("title", {
    id: titleId,
    children: title
  }) : null, /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    d: "M9.707 10.707a1 1 0 1 1-1.414-1.414 1 1 0 0 1 1.414 1.414Zm6 0a1 1 0 1 0-1.414-1.414 1 1 0 0 0 1.414 1.414ZM6.313 14.05a1 1 0 0 0-.76.055v.001a1 1 0 0 0-.447 1.341l.001.003c.361.715.963 1.336 1.581 1.83C7.79 18.163 9.508 19 12 19c2.492 0 4.21-.837 5.312-1.719.62-.495 1.216-1.115 1.58-1.829l.002-.003v-.002a1 1 0 0 0-1.785-.902l-.003.007c-.039.07-.356.618-1.043 1.168C15.29 16.337 14.007 17 12 17c-2.007 0-3.29-.663-4.063-1.281-.687-.549-1.004-1.097-1.043-1.167l-.003-.007a1 1 0 0 0-.578-.495Z"
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    fillRule: "evenodd",
    d: "M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12Zm0-2c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10Z",
    clipRule: "evenodd"
  })]
});